<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
              <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
                <img src="../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                  pluginspage="http://www.adobe.com/svg/viewer/install/" />
                <span>NFO</span>
              </a>
            </li> -->
          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <!-- (remove 07052023)style="padding: 0px;" <div class="SectionTopHeading SectionHeading mb-3">
        <span>
          <img src="../../assets/images/BrandingImages.svg" width="25" class="SideMenuIcon svg"
          type="image/svg+xml" pluginspage="http://www.adobe.com/svg/viewer/install/" />&nbsp;
          Marketing Images
        </span>
      </div> -->
      <div *ngIf="!IsMobile" class="SectionHeading">Marketing Images</div>

      <div
        *ngIf="IsMobile"
        class="CommonSelectBoxTabsOuter CommonSelectBoxForm">
        <div class="SectionTopHeading HeadingReport NewHeaders fixed-top p-0">
          <span class="Mob_Heading_Top">Resources</span>
        </div>
        <div
          class="ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs">
          <ul class="nav nav-tabs p-0 Reports_Mob">
            <li>
              <a
                class="active show"
                routerLink="/value-add-service/branding"
                routerLinkActive="active">
                Branding Images
              </a>
            </li>
            <li>
              <a
                routerLink="/value-add-service/scheme-returns"
                routerLinkActive="active">
                Scheme Returns
              </a>
            </li>
            <li class="d-none">
              <a
                routerLink="/value-add-service/schemeperformancelumpsum"
                routerLinkActive="active">
                Lumpsum Performance
              </a>
            </li>
            <!-- <li>
              <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>NFO</a>
            </li> -->
          </ul>
        </div>
      </div>
      <form
        [formGroup]="FilterForm"
        (ngSubmit)="OnSubmitFilters()"
        class="FormOuter_Mob">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
            <div class="has-float-label">
              <select
                formControlName="Product"
                id="Product"
                class="form-control CommonSelectBox HDFC-Text TbxMarginBtm DdlSelectProduct"
                placeholder="&nbsp;"
                [ngClass]="{
                  'is-invalid': FilterFormSubmitted && f.Product.errors
                }">
                <option value="" disabled="true">Select Product</option>
                <option value="0">All</option>
                <option *ngFor="let m of ProductList" [value]="m.ProductId">
                  {{ m.ProductName }}
                </option>
              </select>
              <!--
              <ng-multiselect-dropdown-angular7 [ngModelOptions]="{standalone: true}"
              [placeholder]="'Select Investor Name'" [data]="ProductList"
              [(ngModel)]="selectedItems" [settings]="dropdownSettings"
              (onSelect)="onItemSelect($event)" (onDeSelect)="onItemSelect($event)"
              (onSelectAll)="onItemSelectDeselectAll($event,0)"
              (onDeSelectAll)="onItemSelectDeselectAll($event,1)">
          </ng-multiselect-dropdown-angular7> -->
              <label for="Product">Product Name</label>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
            <div class="has-float-label">
              <select
                formControlName="Category"
                id="Category"
                class="form-control CommonSelectBox TbxMarginBtm DdlSelectCategory"
                placeholder="&nbsp;"
                [ngClass]="{
                  'is-invalid': FilterFormSubmitted && f.Category.errors
                }">
                <option value="" disabled="true">Select Category</option>
                <option value="0">All</option>
                <option *ngFor="let m of CategoryList" [value]="m.CategoryId">
                  {{ m.CategoryName }}
                </option>
              </select>
              <!-- <ng-multiselect-dropdown-angular7 [ngModelOptions]="{standalone: true}"
              [placeholder]="'Select Category'" [data]="CategoryList"
              [(ngModel)]="selectedItems1" [settings]="dropdownSettings1"
              (onSelect)="onItemSelect1($event)" (onDeSelect)="onItemSelect1($event)"
              (onSelectAll)="onItemSelectDeselectAll1($event,0)"
              (onDeSelectAll)="onItemSelectDeselectAll1($event,1)">
          </ng-multiselect-dropdown-angular7> -->
              <label for="Category">Category Name</label>
            </div>
          </div>
        </div>
        <div *ngIf="!IsMobile" class="row">
          <div class="col-md-3 col-sm-3 col-xs-12 InputBoxOuter">
            <div class="CheckAgree">
              <label class="Cbx_container">
                <input
                  class="customselect0"
                  type="radio"
                  formControlName="CheckFilter0"
                  checked="true"
                  (change)="checkForTodayAll('0')"
                  name="CheckFilter" />
                <span class="checkmark"></span>
                <label>&nbsp;&nbsp;Today & Upcoming</label>
              </label>
            </div>
          </div>

          <div class="col-md-3 col-sm-3 col-xs-12 InputBoxOuter">
            <div class="CheckAgree">
              <label class="Cbx_container">
                <input
                  class="customselect1"
                  type="radio"
                  formControlName="CheckFilter1"
                  (change)="checkForTodayAll('1')"
                  name="CheckFilter" />
                <span class="checkmark"></span>
                <label>&nbsp;&nbsp;Today</label>
              </label>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 InputBoxOuter">
          <div class="CheckAgree">
            <label class="Cbx_container ">
              <input   class="customselect2" type="radio" formControlName='CheckFilter2' checked="true"  (change)="checkForTodayAll('2')"
                name='CheckFilter' value="true" >
              <span class="checkmark"></span>
              <label>
                &nbsp;&nbsp;ALL
              </label>
            </label>
          </div>
        </div> -->
        </div>
        <div *ngIf="IsMobile" class="d-flex">
          <div class="">
            <div class="CheckAgree">
              <label class="Cbx_container">
                <input
                  class="customselect1"
                  type="radio"
                  formControlName="CheckFilter1"
                  (change)="checkForTodayAll('1')"
                  name="CheckFilter" />
                <span class="checkmark"></span>
                <label>&nbsp;&nbsp;Today</label>
              </label>
            </div>
          </div>

          <div class="">
            <div class="CheckAgree">
              <label class="Cbx_container">
                <input
                  class="customselect0"
                  type="radio"
                  formControlName="CheckFilter0"
                  checked="true"
                  (change)="checkForTodayAll('0')"
                  name="CheckFilter" />
                <span class="checkmark"></span>
                <label>&nbsp;&nbsp;Today & Upcoming</label>
              </label>
            </div>
          </div>
          <!-- <div class="">
          <div class="CheckAgree">
            <label class="Cbx_container ">
              <input   class="customselect2" type="radio" formControlName='CheckFilter2' checked="true"  (change)="checkForTodayAll('2')"
                name='CheckFilter' value="true" >
              <span class="checkmark"></span>
              <label>
                &nbsp;&nbsp;ALL
              </label>
            </label>
          </div>
        </div> -->
        </div>
      </form>
      <!-- added by adarsh 16012025 -->
      <div
        *ngIf="false"
        class="FundCardsOuter"
        style="display: grid; grid-template-columns: 1fr 1fr 1fr">
        <div *ngFor="let client of ValueAdedList">
          <div class="card" style="width: 15rem; margin: 10px">
            <img
              src="{{ ServerUrl }}CoBrandingImage/FilesUploaded/BrandingFiles/{{
                client.FileNamewith
              }}"
              alt="AmcLogo" />
            <div class="card-footer">
              <h4 class="card-title">{{ client.CategoryName }}</h4>
              <h6 class="">{{ client.EventName }} - {{ client.EventDate }}</h6>
              <div style="display: flex; justify-content: center">
                <a
                  class="btn btn-primary"
                  (click)="onListPreview(client.BrandingWithEDL)">
                  preview
                </a>
              </div>
            </div>
          </div>
          <div class="SingleFundCard d-none">
            <div class="FundInfo">
              <img
                src="{{
                  ServerUrl
                }}CoBrandingImage/FilesUploaded/BrandingFiles/{{
                  client.FileNamewith
                }}"
                alt="AmcLogo" />
            </div>

            <div class="FundAction" style="text-align: center">
              <div
                class="ActionBtn CursorPointer"
                (click)="onListPreview(client.BrandingWithEDL)">
                preview
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- testing till here -->
      <!-- <div class="SubSection HDFC_BG mx-3" *ngIf='CompanyName != "IFA"'>
        <form [formGroup]="FilterForm" (ngSubmit)="OnSubmitFilters()">
          <div class="row FirstRowTop">
            <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select formControlName="Product" id='Product'
                  class="form-control CommonSelectBox HDFC-Text TbxMarginBtm DdlSelectProduct" placeholder="&nbsp;"
                  [ngClass]="{ 'is-invalid': FilterFormSubmitted && f.Product.errors }">
                  <option value="">Select Product</option>
                  <option *ngFor="let m of ProductList" [value]="m.ProductId">
                    {{m.ProductName}}</option>
                </select>
                <label for="Product">Product Name</label>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label ">
                <select formControlName="Category" id='Category'
                  class="form-control CommonSelectBox  TbxMarginBtm DdlSelectCategory" placeholder="&nbsp;"
                  [ngClass]="{ 'is-invalid': FilterFormSubmitted && f.Category.errors }">
                  <option value="">Select Category</option>
                  <option *ngFor="let m of CategoryList" [value]="m.CategoryName">
                    {{m.CategoryName}}</option>
                </select>
                <label for="Category">Category Name</label>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label ">
                <select formControlName="Type" id='Type'
                  class="form-control CommonSelectBox HDFC-Text TbxMarginBtm DdlSelectType" placeholder="&nbsp;"
                  [ngClass]="{ 'is-invalid': FilterFormSubmitted && f.Type.errors }">
                  <option value="">Select Type</option>
                  <option *ngFor="let m of TypeList" [value]="m.FileTypeValue">
                    {{m.FileType}}</option>
                </select>
                <label for="Type">Type</label>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <button class="CommonSubmitButton BtnSubmit BtnSubmitGrp">Submit</button>
            </div>
          </div>
        </form>
      </div> -->
      <div *ngIf="!IsMobile" class="table-responsive mt-4">
        <!-- <div class ="TopFilters">
          <div class="SearchBox">
            <input type="text" class="ExploreSearch"  name="search" [(ngModel)]="SearchText" autocomplete="off" placeholder="&#61442; Search Event" />
                <!-- <input type="text" placeholder="Search Fund" #SeacrhFund class="ExploreSearch"
                /> -->
        <!--<img type="image/svg+xml" class="searchicon svg" src="../../assets/images/IFA/SearchBlue.svg" />
        </div>
        </div> -->
        <!-- <div class="search-hero">
          Search <input class="form-control" type="text" name="search" [(ngModel)]="SearchText" autocomplete="off" placeholder="&#61442;  Start searching for events">
        </div> -->
        <br />
        <table class="CommonTable thead th" id="brandingList">
          <thead>
            <tr>
              <th class="no-sort">Product</th>
              <th class="no-sort">Category</th>
              <th class="no-sort">Type</th>
              <th class="no-sort">EventDate</th>
              <th class="no-sort">EventName</th>
              <th class="no-sort">Title</th>
              <th class="no-sort">Preview & Download</th>
              <!-- <th style="display:block;">Logo</th>
              <th>Details</th>
              <th>Co brand</th> -->
            </tr>
          </thead>
          <tbody *ngIf="ValueAdedList.length > 0">
            <!-- <tr *ngFor="let client of ValueAdedList | search : SearchText :client.ProductName"> -->
            <tr *ngFor="let client of ValueAdedList">
              <td>{{ client.ProductName }}</td>
              <td>{{ client.CategoryName }}</td>
              <td>{{ client.FileType }}</td>
              <td>{{ client.withSlashesdate }}</td>
              <td>{{ client.EventName }}</td>
              <!-- <td>{{client.FileNamewith}}</td> -->
              <td>
                <span
                  *ngIf="client.FileNamewith.length >= 20"
                  class="tooltiplink"
                  attr.data-target="{{ client.FileNamewith }}"
                  autoPlacement="true">
                  {{ client.FileNamewith | slice: 0 : 21 }}...
                </span>
                <span *ngIf="client.FileNamewith.length < 20">
                  {{ client.FileNamewith }}
                </span>
              </td>
              <td>
                <a
                  class="ColorBlue CursorPointer"
                  (click)="onListPreview(client.BrandingWithEDL)">
                  PREVIEW & DOWNLOAD
                </a>
                <!-- <a class="ColorBlue CursorPointer"
                  (click)="onListDownload(client.BrandingWithEDL,client.FileNamewith)">DOWNLOAD</a>/ -->
                <!-- <a class="ColorBlue CursorPointer" id="btn_download" (click)="downloadToPng()">Download2</a> -->
                <!-- <a class="ColorBlue CursorPointer" [href]="imageLink" download="mergedImage">Download as image</a>-->
              </td>
              <!-- <td style="display:block;">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input type="checkbox" id=id_Logo_{{i}} />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </td>
              <td>
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input type="checkbox" id=id_Details_{{i}} />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </td>
              <td class="ColorBlue CursorPointer" (click)="onClickProceed(i,client.BrandingWithEDL,client.ValueAddID)">
                PROCEED</td> -->
            </tr>
          </tbody>
          <tbody *ngIf="ValueAdedList.length == 0">
            <tr class="NoRecordFound NoRecordFoundAlignTable">
              <td colspan="8">No Record</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="IsMobile" style="margin-top: 14px">
        <div>
          <div class="SummaryOuter">
            <div
              *ngFor="let client of ValueAdedList; let i = index"
              class="TopMost-Inner mb-0">
              <div class="SummaryCard Brdr">
                <div class="TopMost-0 pb-0">
                  {{ client.EventName }}
                  <span class="SubTopMost-0">{{ client.withSlashesdate }}</span>
                </div>
                <div class="SubText_Mob TopMost-1 pt-0">
                  <div>
                    <span
                      *ngIf="client.FileNamewith.length >= 30"
                      class="tooltiplink"
                      attr.data-target="{{ client.FileNamewith }}"
                      autoPlacement="true">
                      {{ client.FileNamewith | slice: 0 : 21 }}...
                    </span>
                    <span *ngIf="client.FileNamewith.length < 30">
                      {{ client.FileNamewith }}
                    </span>
                  </div>
                  <div>
                    <a
                      class="ColorBlue CursorPointer"
                      (click)="onListPreview(client.BrandingWithEDL)">
                      View
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Shadow_Div">
        <img
          class="Blue_Shadow"
          src="../../assets/images/Rounded_Blue_Cut.png" />
      </div>

      <div class="modal" id="CollateralsModal" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content AlertModalContentCls">
            <div class="modal-header AlertModalHeader">
              Personalised Collaterals
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body AlertModalBody">
              <div>
                <div class="mb-2">Name : {{ Name }}</div>
                <div class="mb-2">Mobile : {{ Mobile }}</div>
                <div class="mb-2">Email : {{ Email }}</div>
              </div>
              <div>
                <!-- // <img src="../../assets/images/samplelogo.png" /> -->
                <!-- <img [src]="SubbrokerimageUrl"> -->
              </div>
            </div>
            <div class="modal-footer AlertModalFooter">
              <button
                type="button"
                class="CursorPointer"
                (click)="onClickPreview()">
                Preview
              </button>
              <button
                type="button"
                class="CursorPointer"
                (click)="onClickDownload()">
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="ModelPreview" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content AlertModalContentCls">
            <div class="modal-header AlertModalHeader">
              Preview
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body AlertModalBody">
              <img [src]="imageUrl" class="w-100" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal" id="ModelListPreview" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
          <div
            class="modal-content AlertModalContentCls"
            style="border-radius: 0 !important">
            <div class="modal-header AlertModalHeader">
              <span *ngIf="!IsMobile">Preview</span>
              <!-- <span *ngIf="IsMobile"> Take</span> -->

              <a
                class="ColorBlue CursorPointer"
                *ngIf="IsMobile"
                id="btn_download">
                Take a screenshot and use
              </a>

              <a
                class="ColorBlue CursorPointer"
                *ngIf="!IsMobile"
                id="btn_download"
                (click)="downloadToPng()">
                &nbsp;&nbsp; Download Now
              </a>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body AlertModalBody p-0" id="convertToImage">
              <img
                [src]="ListimageUrl"
                class="w-100"
                style="max-height: 100%" />
              <!-- Added by adarsh  -->
              <div
                *ngIf="!IsMobile"
                id="mod_bod"
                style="margin-top: -113px; padding: 7px 14px 7px 14px">
                <div
                  style="
                    display: grid;
                    grid-template-columns: 0.65fr 1fr 80px;
                    align-content: center;
                    gap: 14px;
                  ">
                  <div id="logoimage">
                    <img [src]="Logourl" class="img-fluid LogoResources" />
                  </div>
                  <div style="line-height: 18px">
                    <div class="FooterNames">{{ MFDCompanyName }}</div>
                    <div class="FooterNames1 d-none">{{ Name }}</div>
                    <div class="FooterNames2">{{ Mobile }}</div>
                    <div class="FooterNames3" style="margin-bottom: 1px">
                      Email : {{ Email }}
                    </div>
                    <div class="FooterNames3">Website : {{ Website }}</div>
                    <div class="FooterNames3">{{ AppName }}</div>
                  </div>
                  <div
                    class="QRImage"
                    style="
                      margin: 0px 0px 0px;
                      display: flex;
                      justify-content: end;
                    ">
                    <img
                      [src]="UploadedQR"
                      class="img-fluid"
                      style="height: 76px" />
                  </div>
                </div>
              </div>
              <div *ngIf="IsMobile" id="mod_bod" style="margin-bottom: -18px">
                <div
                  style="
                    /* display: flex; */
                    align-content: center;
                    justify-content: flex-start;
                    align-items: center;
                    flex-direction: row;
                    margin-top: -100px;
                    height: 105px;
                    padding: 0px;
                  ">
                  <div
                    style="
                      display: grid;
                      grid-template-columns: 0.65fr 1fr 1fr;
                      align-content: center;
                      gap: 11px;
                    ">
                    <div id="logoimage">
                      <img [src]="Logourl" class="img-fluid LogoResources" />
                    </div>
                    <div style="margin-left: 6px; line-height: 14px">
                      <div class="FooterNames">{{ MFDCompanyName }}</div>
                      <div class="FooterNames1 d-none">{{ Name }}</div>
                      <div class="FooterNames2">{{ Mobile }}</div>
                      <div class="FooterNames3">{{ Email }}</div>
                      <div class="FooterNames3">{{ Website }}</div>
                      <div
                        class="FooterNames3"
                        *ngIf="AppName != '' || AppName != null">
                        {{ AppName }}
                      </div>
                    </div>
                    <div class="QRImage">
                      <img
                        [src]="UploadedQR"
                        class="img-fluid"
                        style="height: 60px" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- till here -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<span *ngIf="!IsMobile">
  <app-footer></app-footer>
</span>
